import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";

import rwn1 from "../../Images/ReverseWaterfallNaneghat/rwn1.jpg";
import rwn2 from "../../Images/ReverseWaterfallNaneghat/rwn2.jpg";
import rwn3 from "../../Images/ReverseWaterfallNaneghat/rwn3.jpg";
import dev1 from "../../Images/Devkund/dev1.jpg";
import dev2 from "../../Images/Devkund/dev2.JPG";

const data = [
  {
    day: "Day 1",
    subheading: "Journey Begins",
    schedule: [
      { time: "11:00 PM", activity: "Pickup at Bora Classes, Shastri Nagar." },
      { time: "11:30 PM", activity: "Pickup at BMCC Ground, Deccan." },
      { time: "12:15 AM", activity: "Pickup at Xion Mall, Hinjewadi." },
      {
        time: "Late Night",
        activity:
          "Travel continues through the night with a relaxed group atmosphere and light rest on the bus.",
      },
    ],
    meals: ["Night travel"],
    notes: [
      "This journey starts with an overnight travel plan and a fixed pickup route. Please be ready at the pickup point before the stated time.",
    ],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast & Tea",
      "🥘 Lunch & Evening Tea",
      "🧭 Experienced Trek Leader & Local Guide",
      "🩺 Basic First Aid & Hydration Support",
      "🏞️ Entry & Local Charges",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Personal insurance or medical expenses.",
      "Any emergency evacuation charges.",
      "Photography or videography permits (if applicable).",
    ],
    verticalCards: [
      { title: "Night Travel Route", image: rwn1 },
      { title: "Waterfall Trail", image: rwn2 },
      { title: "Forest View", image: dev1 },
      { title: "Riverbank Scene", image: dev2 },
      { title: "Mountain Landscape", image: rwn3 },
    ],
    trekData: [
      {
        name: "Nanemachi Trek with Satsada Falls",
        image: rwn1,
        info: "This trip pairs an overnight journey with a scenic trek experience through a peaceful forest trail and a waterfall destination. The plan is designed for trekkers who enjoy early starts, calm landscapes, and a mix of nature and adventure. The route brings together fresh air, misty greenery, and the thrill of discovering a hidden waterfall spot near the countryside.",
      },
    ],
    faq: [
      {
        question: "What is the pickup plan for Day 1?",
        answer:
          "The trip begins with pickups at Bora Classes, Shastri Nagar, BMCC Ground, Deccan, and Xion Mall, Hinjewadi.",
      },
      {
        question: "Is this trek suitable for beginners?",
        answer:
          "Yes, the experience is suitable for beginners who are comfortable walking on uneven terrain and can handle a full day of outdoor activity.",
      },
      {
        question: "What should I carry?",
        answer:
          "Carry a small backpack, water bottle, raincover, trekking shoes, extra clothes, and personal medicines.",
      },
      {
        question: "Are meals included?",
        answer: "Yes, breakfast, lunch, and tea are included as per the plan.",
      },
    ],
  },
  {
    day: "Day 2",
    subheading: "Nanemachi Trek with Satsada Falls",
    schedule: [
      {
        time: "05:00 AM",
        activity: "Reach the base village and prepare for the trek.",
      },
      {
        time: "06:00 AM",
        activity: "Enjoy breakfast and begin the trek toward the waterfall.",
      },
      {
        time: "10:00 AM",
        activity: "Return to the base village for lunch and rest.",
      },
      {
        time: "12:00 PM",
        activity:
          "Head to the Satsada waterfall area for sightseeing and photography.",
      },
      { time: "02:00 PM", activity: "Begin the return journey to Pune." },
      {
        time: "07:00 PM to 08:00 PM",
        activity: "Arrive in Pune, subject to traffic conditions.",
      },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: [
      "The exact return timing may shift slightly depending on road traffic and group pace.",
    ],
  },
];

const NanemachiTrekSatsadaFalls = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Nanemachi Trek with Satsada Falls"
          location="Nanemachi & Satsada Falls"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default NanemachiTrekSatsadaFalls;
